import React, { Component } from 'react'
import ReactPlayer from 'react-player';

// import Button from '@mui/material/Button';
import './ProducerPlayer.scss';

import { Producer } from '../../models/producerClass';
import { InitialsContainer } from './InitialsContainer';

type MyProps = {
  // using `interface` is also ok
  producer: Producer,
  name: string,
  isSpotted: boolean,
  audioMute: boolean,
  onToggleSpotted?: any,
  videoMute: boolean,
  initials: string,
  url: string,
};
type MyState = {
  url: string,
  playing: boolean,
  volume: number,
  audioMute: boolean,
  played: number,
  toggleSpotted: any,
  isSpotted: boolean,
  videoMute: boolean,
  initials: string,
  zoom: string,
};


class ProducerLiveComponent extends Component<MyProps, MyState> {
  player: any = '';

  state: MyState = {
    url: '',
    playing: true,
    volume: 0.8,
    audioMute: true,
    played: 0,
    toggleSpotted: null,
    isSpotted: false,
    videoMute: false,
    initials: '',
    zoom: '104%',
  }

  constructor(props: any) {
    super(props);
    const zoom = props.url.indexOf('contentshare') >= 0 ? '100%' : '104%';

    this.state = {
      ...this.state,
      url: props.url,
      audioMute: props.audioMute,
      toggleSpotted: props.onToggleSpotted,
      isSpotted: false,
      videoMute: props.videoMute,
      initials: props.initials,
      zoom
    };
  }

  UNSAFE_componentWillReceiveProps(props) {
    // console.log('componentWillReceiveProps', props);
    const zoom = props.url.indexOf('contentshare') >= 0 ? '100%' : '104%';

    this.setState({
      isSpotted: props.isSpotted,
      audioMute: props.audioMute,
      videoMute: props.videoMute,
      initials: props.initials,
      url: props.url,
      zoom: zoom,
    });
  }


  handleToggleSpotted = () => {
    const isSpotted = !this.state.isSpotted; // inverse old state
    if (this.state.toggleSpotted) {
      this.state.toggleSpotted(isSpotted);
      // this.setState({isSpotted});
    }
  }


  ref = (player: any) => {
    this.player = player
  }


  handleClick = (e) => {
    if (e.detail === 2) {
      this.handleToggleSpotted();
    }
  }


  render() {
    return (
      <div className='player-container player-container-no-padding' onClick={(e) => this.handleClick(e)}>

        {(this.state.url && this.state.url.indexOf('webrtc') >= 0) || this.state.videoMute ?
          <div className='stream-wrapper'>
            <div className='stream-player'>
              {!this.state.videoMute ?
                <video id={'live-' + this.state.url}
                  playsInline muted autoPlay className="stream-video stream-live"></video>
                :
                <InitialsContainer isLive={true}>{this.state.initials}</InitialsContainer>
              }
            </div>
          </div>
          : // fake player for demo
          this.state.url.indexOf('showing-local-content') >= 0 ?
            <div className='stream-wrapper local-content'>
              <div className='local-content-logo'></div>
              <div className='local-content-heading'>You are sharing your screen</div>
            </div>
            :
            <div className='player-wrapper'>
              <ReactPlayer
                className='player-react'
                width={this.state.zoom}
                height={this.state.zoom}
                ref={this.ref}
                url={this.state.url}
                playing={this.state.playing}
                controls={false}
                muted={this.state.audioMute}
                loop={true}
                volume={this.state.volume}
                onError={e => console.log('onError', e)}
              />
            </div>


        }

      </div>

    )
  }
}

export default ProducerLiveComponent;